(function ($, window, document) {

  document.addEventListener("DOMContentLoaded", function() {
    $(window).resize(adjust);
    var anchor = window.location.hash.replace('#', '');
    var $features = $('.feature-table__content');
    var tableWidth = $('.feature-table').width();
    var thFirst = $('.feature-table th:first')
    var thOthers = $('.feature-table th:not(:first)')

    function adjust() {
      tableWidth = $('.feature-table').width();
      // change column widths for small screens
      if (tableWidth <= 520) {
        thOthers.removeClass('col-xs-2')
        thOthers.addClass('col-xs-1')
        thFirst.removeClass('col-xs-6')
        thFirst.addClass('col-xs-9')
      } else if (tableWidth > 480 && thFirst.hasClass('col-xs-9') && thOthers.hasClass('col-xs-1')) {
        thOthers.removeClass('col-xs-1')
        thOthers.addClass('col-xs-2')
        thFirst.removeClass('col-xs-9')
        thFirst.addClass('col-xs-6')
      }
    }

    function collapse() {
      $features.each(function () {
        if ($(this).attr('id') != anchor) {
          $(this).removeClass('in');
        } else {
          var $target = $('#' + anchor);
          if ($target.length) {
            setTimeout(function () {
              $('html,body').animate({ scrollTop: $target.prev().offset().top }, 1000);
            }, 100);
          }
        }

        $(this).on('show.bs.collapse', function(el) {
          var content = $(el.currentTarget)
          content.closest('tr').addClass('open').closest('table').addClass('open');

          var tr = content.closest('tr')

          // guestimate content height
          var height = tr.data('height')
          if (!height) {
            height = content.height() + 33
          }
          content.closest('tr').css('height', height + 'px').data('height', height)
          setTimeout(function () {
            var srElement = document.getElementById("sr-" + content[0].id);
            srElement.focus();
            var descriptionElement = tr.find('th div');
            descriptionElement.attr('aria-hidden', 'false');
            setTimeout(function () {
              var focusElement = tr.find('.feature-table__title');
              focusElement.focus();
            }, 100);
          }, 100);
        })

        $(this).on('shown.bs.collapse', function(el) {
          var content = $(el.currentTarget)

          // adjust row height based on known height
          var height = content.parent().height() + 9
          content.closest('tr').css('height', height + 'px')
        })

        $(this).on('hide.bs.collapse', function(el) {
          var content = $(el.currentTarget)
          content.closest('tr').removeClass('open').css('height' , 'auto').closest('table').removeClass('open');
          setTimeout(function () {
            var srElement = document.getElementById("sr-" + content[0].id);
            srElement.focus();
            content.attr('aria-hidden', 'true');
            setTimeout(function () {
              var focusElement = content.parent().find('.feature-table__title');
              focusElement.focus();
            }, 100);
          }, 100);
        })
      });
    }

    function closeHandler(event) {
      $(event.currentTarget).parent().collapse('hide')
      event.preventDefault()
    }

    // adjust and collapse when document is ready
    adjust();
    collapse();

    $('.feature-table').on('click', 'a.close', closeHandler)
  });

})($, window, document);
